import { BrowserRouter, StaticRouter } from 'react-router-dom';
import Layout from '@/components/Layout';
import { resolveBasenameFromPath, resolveStaticRouterLocation } from '@/ssr/routerPath';

export type AppProps = {
  /** Full request path (e.g. `req.originalUrl` without hash). Server-only SSR render. */
  ssrLocation?: string;
};

export default function App({ ssrLocation }: AppProps = {}) {
  if (ssrLocation !== undefined) {
    const pathOnly = ssrLocation.split('?')[0] || '/';
    const basename = resolveBasenameFromPath(pathOnly);
    const location = resolveStaticRouterLocation(ssrLocation, basename);
    return (
      <StaticRouter basename={basename} location={location}>
        <Layout />
      </StaticRouter>
    );
  }

  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}
